import * as React from 'react';
import classnames from 'classnames';
import { formStyles } from 'styles/formStyles';
import { formatSmDateTime } from 'utils/formatter';
import { useBetreuerByKz } from 'api/betreuer';

export enum TimestampType {
    created,
    modified,
}

interface TimestampProps {
    date?: string;
    decimalTime?: number;
    user?: string;
    type: TimestampType;
}

export const Timestamp: React.FC<TimestampProps> = ({ date, decimalTime, user, type }) => {
    const betreuerByKz = useBetreuerByKz();
    return (
        <div className={classnames(formStyles.line, formStyles.timestamp)}>
            {formatSmDateTime(date, decimalTime)} - {type === TimestampType.created ? 'Angelegt von ' : 'Geändert von '}
            {user && (betreuerByKz[user] ? betreuerByKz[user].name : user)}
        </div>
    );
};
